export var epsilon = 1e-12;
export var pi = Math.PI;
export var halfPi = pi / 2;
export var tau = 2 * pi;



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/d3-shape/src/math.js
// module id = 321
// module chunks = 0